<template>
    <div v-if="config['banners'] != undefined" class="pb-special">
        <div id="container-carousel" class="w-full h-full relative z-10">
            <Carousel :banners="config['banners']" />
        </div>
        <div id="container-cards" class="grid md:grid-cols-2 md:gap-4 mx-special mt-text">
            <div class="h-full">
                <DataCard data-type="television-data" :data-json="config" style-type="primary-card" />
            </div>
            <div class="h-full max-md:pt-special">
                <DataCard data-type="radio-data" :data-json="config" style-type="primary-card" />
            </div>
        </div>
        <div id="container-card-fundator" class="mx-special mt-special">
            <DataCard data-type="fundator-data" :data-json="config" style-type="photo" />
        </div>
    </div>
</template>

<script setup>
import { onBeforeMount, ref, nextTick } from 'vue';

import DataCard from '../components/utils/DataCard.vue'
import Carousel from '../components/utils/Carousel.vue'
import { generalStore } from '@/stores';

const store = generalStore();
const route = store.route;
var config = ref([]);
store.setIsPP(true);

onBeforeMount(async () => {
    window.scrollTo(top);
    await store.getConfiguration(route.name);
    await nextTick()
    config.value = store.getSessionStorage('configuration-' + route.name);
})
</script>